import { callAPI } from '../../../utils/call-api'

export const patchExtendFinish = async ({ token, orderId, data }) =>
  callAPI(
    {
      url: `/orders/${orderId}/extend-finish`,
      method: 'patch',
      data,
    },
    token
  )

export const postOrderReview = async ({ token, data }) =>
  callAPI(
    {
      url: '/order-review',
      method: 'post',
      data,
    },
    token
  )
